import { render } from "./ProjectDetail.vue?vue&type=template&id=729461b2&scoped=true&ts=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=ts"
export * from "./ProjectDetail.vue?vue&type=script&lang=ts"

import "./ProjectDetail.vue?vue&type=style&index=0&id=729461b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729461b2"]])

export default __exports__